import { SkeletonLoader } from "~/shared/components/SkeletonLoader";
import { ModuleContainer } from "~/templates/blocks/shared/ModuleContainer";
import { Section, SkeletonContainer, SkeletonSpacer } from "./styled";

export default function UserProfileSkeleton() {
  return (
    <ModuleContainer>
      <Section>
        <SkeletonLoader height={35} width={150} />
        <SkeletonSpacer height={9} />
        <SkeletonContainer>
          <SkeletonLoader height={20} width={200} />
          <SkeletonSpacer height={6} />
          <SkeletonLoader height={50} isFullWidth />
          <SkeletonLoader height={50} isFullWidth />
          <SkeletonLoader height={50} isFullWidth />
          <SkeletonLoader height={50} isFullWidth />
        </SkeletonContainer>
        <SkeletonSpacer height={34} />
        <SkeletonContainer>
          <SkeletonLoader height={20} width={200} />
          <SkeletonSpacer height={6} />
          <SkeletonLoader height={50} isFullWidth />
          <SkeletonLoader height={50} isFullWidth />
          <SkeletonLoader height={50} isFullWidth />
        </SkeletonContainer>
        <SkeletonSpacer height={10} />
        <SkeletonContainer>
          <SkeletonLoader height={50} isFullWidth />
          <SkeletonLoader height={50} isFullWidth />
          <SkeletonLoader height={50} isFullWidth />
          <SkeletonLoader height={50} isFullWidth />
          <SkeletonLoader height={50} isFullWidth />
        </SkeletonContainer>
      </Section >
    </ModuleContainer>
  );
}
